import { render, staticRenderFns } from "./publicBottom.vue?vue&type=template&id=02371e07&scoped=true"
import script from "./publicBottom.vue?vue&type=script&lang=js"
export * from "./publicBottom.vue?vue&type=script&lang=js"
import style0 from "./publicBottom.vue?vue&type=style&index=0&id=02371e07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02371e07",
  null
  
)

export default component.exports